<template>
  <div class="login-modal">
    <div class="login-card">
      <div class="header-login-card">
        <div class="brand-logo-container">
          <img src="../assets/acuity_logo.png" class="brand-logo" alt="acuity" />
        </div>
      </div>
      <div class="content-login-card">
        <form class="login-form" @submit.prevent="login">
          <div class="field-groupped">
            <button class="login-addons" id="icon-users">
              <font-awesome-icon :icon="['fas', 'users']" />
            </button>
            <input tabindex="1" ref="orgaInput" type="text" class="form-control" name="organisation" :placeholder="$t('login.orga')" v-model="organization"/>
          </div>
          <div class="field-groupped">
            <button class="login-addons">
              <font-awesome-icon :icon="['fa', 'user']"/>
            </button>
            <input tabindex="2" ref="usernameInput" type="text" class="form-control" name="username" :placeholder="$t('login.username')" v-model="username"/>
          </div>
          <div class="field-groupped">
            <button class="login-addons">
              <font-awesome-icon :icon="['fas', 'key']" />
            </button>
            <input tabindex="3" ref="pwdInput" type="password" class="form-control"  :placeholder="$t('login.password')" v-model="password"/>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="customControlInline" v-model="rememberMe" name="remember"/>
            <label class="custom-control-label" for="customControlInline">{{$t("login.remember_me")}}</label>
          </div>
          <div class="footer-login-card">
            <div>
              <button ref="loginButton" class="login-button" @click="login">{{ $t("login.login") }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      organization: localStorage.getItem('ORGA_ID'),
      username: localStorage.getItem('USERNAME'),
      password: '',
      rememberMe: Boolean
    }
  },
  mounted () {
    this.focusInput()
  },
  computed: {
    hasError: function () {
      return this.$store.getters['authentication/authStatus'] === 'error'
    }
  },
  methods: {
    login: function () {
      // validation
      if (!this.organization || !this.username || !this.password) {
        this.focusInput()
        return
      }

      this.$log.info('Authentication of user: ' + this.username + ' from orga: ' + this.organization)
      const { organization, username, password, rememberMe } = this

      this.$store.dispatch('authentication/login', { organization, username, password, rememberMe }).then(() => {
        // navigate to current location to refresh the page et let the rooter doing his job
        this.$router.go()
      })
    },
    focusInput: function () {
      if (this.organization === '' || this.organization == null) {
        this.$refs.orgaInput.focus()
      } else if (this.username === '' || this.username == null) {
        this.$refs.usernameInput.focus()
      } else {
        this.$refs.pwdInput.focus()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$ac-primary: #448993;
$ac-light-blue: #70aab3;
$ac-secondary: #ac936c;
$ac-red: #b65640;
$ac-grey: #434343;
$ac-light-grey: #909091;

#icon-users {
  color: white;
}

.login-modal {
  background: $ac-primary;
  z-index: 90;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
}
.login-card {
  height: 400px;
  width: 350px;
  margin: auto;
  background: white;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
}
.header-login-card {
  justify-content: center;
  display: flex;
}
.brand-logo-container {
  position: absolute;
  height: 120px;
  width: 230px;
  top: -50px;
  border-radius: 6px;
  background: $ac-primary;
  padding: 10px;
  text-align: center;
}
.brand-logo {
  height: 100px;
  width: 210px;
  border-radius: 6px;
  border: 2px solid white;
  background-color: white;
}
.content-login-card {
  margin-top: 100px;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding: 0 2rem;
}
.login-form {
  width: 100%;
}
.field-groupped {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
  padding-bottom: 1rem;
}
.login-addons {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  margin-right: -1px;
  background-color: $ac-primary;
  display: flex;
  color: white !important;
  border: 0 !important;
  border-radius: 0.25rem 0 0 0.25rem !important;
  width: 42px;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
}
.login-addons > svg {
  margin: auto;
}
.form-control {
  display: block;
  // width: 100%;
  height: 34px;
  padding: 6px 12px;
  // font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.field-groupped > .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
  box-shadow: none !important;
  outline: 0px !important;
}
/** CUSTOM CHECKBOX **/
.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-control-label {
  position: relative;
  margin-bottom: 0;
  display: inline-block;
  font-weight: inherit !important;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: $ac-primary !important;
}
.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #dee2e6;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("../assets/tick.svg");
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}
/**
* END CUSTOM CHECKBOX
*/

/** FOOTER **/
.footer-login-card {
  margin-top: 2rem;
}

.login-button {
  width: 100%;
  background: $ac-primary;
  color: white;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
